import { Modal } from "antd";
import React, { useState } from "react";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/styles.min.css";
import green_$ from "../../assets/product_tags/$ (3).png";
import alcohol_original from "../../assets/product_tags/alcohol_original.png";
import animal_original from "../../assets/product_tags/animal_original.png";
import ecofriendly_original from "../../assets/product_tags/ecofriendly_original.png";
import grey_$ from "../../assets/product_tags/envelope.png";
import fragrancefree_original from "../../assets/product_tags/fragrancefree_original.png";
import noncomedogneic_original from "../../assets/product_tags/noncomedogneic_original.png";
import parabenfree_original from "../../assets/product_tags/parabenfree_original.png";
import slsfree_original from "../../assets/product_tags/slsfree_original.png";

export const ReportProduct = ({
  tags,
  price,
  name,
  product_img,
  description,
}) => {
  const product_tags = {
    "Paraben-free": parabenfree_original,
    "Not Animal-tested": animal_original,
    "Alcohol-free": alcohol_original,
    "Eco friendly": ecofriendly_original,
    "Fragrance-free": fragrancefree_original,
    "Non-Comodegenic": noncomedogneic_original,
    "Sls-free": slsfree_original,
  };

  const priceIcons = {
    low: [grey_$, grey_$, green_$],
    medium: [grey_$, green_$, green_$],
    high: [green_$, green_$, green_$],
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <div className="p-4  px-5 ">
      <div className="flex justify-between">
        <div className="grid grid-cols-2 gap-1 h-full">
          {tags?.map((tag) => (
            <div className="inline" key={tag} style={{ margin: 0, padding: 0 }}>
              <img src={product_tags[tag]} alt={tag} className="w-[30px]" />
            </div>
          ))}
        </div>

        <div className="flex gap-1">
          {priceIcons[price]?.map((icon, index) => (
            <img
              key={index}
              src={icon}
              alt={`price-${index}`}
              className="w-[15x] h-[20px]"
            />
          ))}
        </div>
      </div>
      <div className=" flex justify-center items-center">
        <div
          className="w-full h-full"
          style={{
            width: "130px",
            height: "240px",
            padding: "10px",
            cursor: "pointer",
          }}
          onClick={() => setIsModalVisible(true)}
        >
          <img
            src={product_img}
            style={{
              width: "100% !important",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>
      </div>
      <span className="font-martel-sans block text-center">{name}</span>
      <Modal
        className="custom-dark-modal"
        title={name}
        open={isModalVisible}
        footer={null}
        onCancel={() => {
          setIsModalVisible(false);
        }}
        width={800}
        style={{
          maxHeight: "80vh",
          top: "10vh",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            height: "100%",
            width: "100%",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              overflow: "hidden",
              flex: 6,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <InnerImageZoom
              src={product_img}
              zoomType="hover"
              alt={name}
              zoomScale={1.1}
              hasSpacer={false}
            />
          </div>

          <div
            style={{
              flex: 4,
              padding: "20px",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              paddingRight: 0,
            }}
          >
            <h2 style={{ fontWeight: "bold", fontSize: "18px" }}>{name}</h2>
            {description && (
              <p style={{ fontSize: "14px", marginBottom: "16px" }}>
                {description}
              </p>
            )}
            <div style={{ marginBottom: "16px" }}>
              <h4
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Tags
              </h4>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "2px" }}>
                {tags?.map((tag) => (
                  <div
                    key={tag}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "4px 8px",
                      border: "0.5px solid #ccc",
                      borderRadius: "10px",
                      fontSize: "14px",
                    }}
                  >
                    <img
                      src={product_tags[tag]}
                      alt={tag}
                      style={{ width: "20px", height: "20px" }}
                    />
                    <span>{tag}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
